import Auth from "../Auth";
import Subscription from "../models/Subscription";

export default class UserCache {

  constructor() {
    this.users = {};
    this.searchedUsers = {};
    this.fetchedAll = false;
  }

  async fetchIds(ids) {
    let missingIds = [];
    for (let id of ids) {
      if (!this.users[id]) {
        missingIds.push(id);
      }
    }

    if (missingIds.length !== 0) {
      let uniqueIds = [...new Set(missingIds)];

      let result = await Auth.fetchWithIdToken("/api/admin/users", {
        ids: uniqueIds
      });

      this.saveUsers(result.users);
    }
    return true;
  }

  async fetchEmails(emails) {

    const uniqueEmails = [...new Set(emails)];

    const result = await Auth.fetchWithIdToken("/api/admin/users", {
      emails: uniqueEmails
    });

    if (!result.error) {
      this.saveUsers(result.users);
      return result.users;
    } else {
      return null;
    }
  }

  async fetchAll() {
    if (!this.fetchedAll) {
      let result = await Auth.fetchWithIdToken("/api/admin/allUsers", {});

      let users = result.users;

      this.saveUsers(users);

      this.fetchedAll = true;
    }

    return Object.values(this.users);
  }

  async fetchSearched(search) {
    const trimmedSearch = search?.trim?.() ?? "";
    const resultsByName = await Auth.fetchWithIdToken("/api/admin/usersMatchingName", { search: trimmedSearch });
    const resultsByEmail = await Auth.fetchWithIdToken("/api/admin/usersMatchingEmail", { search: trimmedSearch });
    const resultsByUserId = await Auth.fetchWithIdToken("/api/admin/usersMatchingId", { search: trimmedSearch });

    let resultsByStripeCustomerId = { users: [] };
    // Only search by Stripe Customer ID if the search starts with "cus_"
    if (trimmedSearch.toLowerCase().startsWith("cus_")) {
      resultsByStripeCustomerId = await Auth.fetchWithIdToken("/api/admin/usersMatchingStripeCustomerId", { search: trimmedSearch });
    }

    const results = [...resultsByName.users, ...resultsByEmail.users, ...resultsByUserId.users, ...resultsByStripeCustomerId.users];

    this.saveSearchedUsers(results);
    const outUsers = Object.values(this.searchedUsers);

    return outUsers;
  }

  async fetchSome() {
      let result = await Auth.fetchWithIdToken("/api/admin/someUsers", {});

      let users = result.users;
      this.saveUsers(users);

    return Object.values(this.users);
  }

  saveUsers(users) {
    for (let user of users) {
      let s = new Subscription(user.uid);
      s.fetchFromDoc(user.subscription);
      user.subscription = s;
      this.users[user.uid] = user;
    }
  }

  saveSearchedUsers(users) {
    this.searchedUsers = {};

    for (let user of users) {
      let s = new Subscription(user.uid);
      s.fetchFromDoc(user.subscription);
      user.subscription = s;
      this.searchedUsers[user.uid] = user;
    }
  }

  getUser(id) {
    return this.users[id];
  }

  getUserByEmail(email) {
    let id = Object.keys(this.users).find(id => this.users[id].email.toLowerCase() === email.toLowerCase());

    return this.users[id];
  }

}
